
export const FIVE_MPH = 8.04672;
export const SOURCE_PUBSUB = "PUBSUB";
export const SOURCE_GPS = "GPS";
export const SOURCE_IOX = "IOX";